// Drawer component for side panels

import { css, html } from 'lit';
import { BaseComponent } from '../../lib/base-component.js';

/**
 * Sliding drawer panel component
 * Used for side panels in game UI (character sheet, effects, etc.)
 */
class DrawerPanel extends BaseComponent {
  static properties = {
    open: { type: Boolean },
    width: { type: Number },
    position: { type: String }, // 'left' or 'right'
  };

  static styles = css`
    :host {
      display: block;
      width: 0;
      height: 100%;
      background: #000000;
      border-left: 4px solid #555;
      overflow: hidden;
      transition: width 0.3s ease-in-out;
      flex-shrink: 0;
      z-index: 100;
      position: relative;
    }

    :host([open]) {
      width: var(--drawer-width, 320px);
    }

    :host([position='left']) {
      border-left: none;
      border-right: 4px solid #555;
    }

    .drawer-content {
      padding: 10px;
      height: 100%;
      overflow-y: auto;
      color: #fff;
      width: var(--drawer-width, 320px);
    }
  `;

  constructor() {
    super();
    this.open = false;
    this.width = 320;
    this.position = 'right';
  }

  async connectedCallback() {
    await super.connectedCallback();
    this.style.setProperty('--drawer-width', `${this.width}px`);
  }

  /** @param {Map<string, unknown>} changedProperties */
  updated(changedProperties) {
    if (changedProperties.has('width')) {
      this.style.setProperty('--drawer-width', `${this.width}px`);
    }
  }

  render() {
    return html`
      <div class="drawer-content">
        <slot></slot>
      </div>
    `;
  }
}

customElements.define('drawer-panel', DrawerPanel);
